export default "__VITE_ASSET__d0230a4b__"